import React, { useEffect } from 'react';
import { useMsal } from '@azure/msal-react';
import { loginRequest } from '../config/authConfig';
import Logo from './Logo';

const Login: React.FC = () => {
  const { instance, accounts, inProgress } = useMsal();

  useEffect(() => {
    console.log('Login component mounted');
    console.log('Accounts:', accounts);
    console.log('In progress:', inProgress);
    console.log('Client ID:', process.env.REACT_APP_CLIENT_ID);
    console.log('Redirect URI:', process.env.REACT_APP_REDIRECT_URI);
    
    // Check if we have any accounts
    if (accounts.length > 0) {
      console.log('Found existing accounts:', accounts);
    }
  }, [accounts, inProgress]);

  const handleLogin = () => {
    console.log('Initiating login redirect...');
    instance.loginRedirect(loginRequest).catch((e) => {
      console.error('Login failed:', e);
    });
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-pottery-cream via-pottery-sand to-clay-100">
      <div className="max-w-md w-full space-y-8 p-8 bg-pottery-cream rounded-xl shadow-lg border border-clay-200">
        <div className="text-center">
          <div className="flex justify-center mb-6">
            <Logo size="lg" />
          </div>
          <h2 className="mt-6 text-3xl font-bold text-pottery-earth">
            Imperfekton Inventaragent
          </h2>
          <p className="mt-2 text-sm text-clay-600">
            KI-gestütztes Inventar-Verwaltungssystem für Töpferei
          </p>
        </div>
        
        {/* Debug Information */}
        {process.env.NODE_ENV === 'development' && (
          <div className="text-xs text-clay-400 bg-clay-50 p-2 rounded">
            <p>Konten: {accounts.length}</p>
            <p>In Bearbeitung: {inProgress}</p>
            <p>Client-ID: {process.env.REACT_APP_CLIENT_ID?.substring(0, 8)}...</p>
          </div>
        )}
        
        <div className="mt-8 space-y-6">
          <div className="text-center">
            <div className="mx-auto h-16 w-16 bg-clay-100 rounded-full flex items-center justify-center">
              <svg className="h-8 w-8 text-clay-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
            </svg>
            </div>
          </div>
          
          <button
            onClick={handleLogin}
            disabled={inProgress !== 'none'}
            className="group relative w-full flex justify-center py-3 px-4 border border-transparent text-sm font-medium rounded-md text-pottery-cream bg-clay-600 hover:bg-clay-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-clay-500 transition duration-150 ease-in-out disabled:opacity-50 shadow-sm hover:shadow"
          >
            <span className="absolute left-0 inset-y-0 flex items-center pl-3">
              <svg className="h-5 w-5 text-clay-500 group-hover:text-clay-400" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M5 9V7a5 5 0 0110 0v2a2 2 0 012 2v5a2 2 0 01-2 2H5a2 2 0 01-2-2v-5a2 2 0 012-2zm8-2v2H7V7a3 3 0 016 0z" clipRule="evenodd" />
              </svg>
            </span>
            {inProgress !== 'none' ? 'Wird verarbeitet...' : 'Mit Microsoft-Konto anmelden'}
          </button>
          
          <div className="text-xs text-clay-500 text-center">
            Sichere Authentifizierung mit Microsoft Azure
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login; 